/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum Side {
	PULL = 'pull',
	ACTIVE = 'active',
	UNKNOWN = 'unknown',
}
